import React, { useState } from 'react';
import { userServices } from '../../APIServices/userServices';

function TopBar({
  crumbs,
  topSearch,
  setTopSearch,
  currentUserData,
}) {
  const [showUserMenu, setShowUserMenu] = useState(false);
  const logoutAdmin = async (e) => {
    e.preventDefault();
    await userServices.logout({});
  };
  const fullName = [currentUserData?.firstName, currentUserData?.middleName, currentUserData?.lastName]
    .filter(Boolean)
    .join(" ");

  return (
    <div className="topbar">
      <div className="crumbs">
        {crumbs.map((c, i) => (
          <React.Fragment key={i}>
            <span className={i === crumbs.length - 1 ? 'cur' : ''}>
              {c}
            </span>
            {i < crumbs.length - 1 && (
              <i className="ti ti-chevron-right" />
            )}
          </React.Fragment>
        ))}
      </div>

      <div className="topbar-user">
        <button
          className="btn btn-ghost topbar-user-button"
          onClick={() => setShowUserMenu((prev) => !prev)}
          aria-expanded={showUserMenu}
          aria-haspopup="menu"
        >
          <div className="user-avatar">
            {currentUserData?.roleType === "admin" ? "A" : "SA"}
          </div>

          <span className="topbar-user-name">{fullName}</span>

          <i className="ti ti-chevron-down" />
        </button>

        {showUserMenu && (
          <div className="topbar-user-menu" role="menu">
            <div className="topbar-user-summary">
              <div className="topbar-user-fullname">{fullName}</div>

              <div className="topbar-user-role">
                User
              </div>

              <div className="topbar-user-email">{currentUserData?.email}</div>
            </div>

            <button
              onClick={logoutAdmin}
              className="topbar-menu-action"
              role="menuitem"
            >
              <i className="ti ti-logout" />
              Sign Out
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default TopBar;
